
import { DELIMITER } from './AnalyticsDelimiterConstants';

const WILL_GET_CUSTOM_DATA = true;

const CATEGORY = `ManageTenants${DELIMITER}Leases`;

const LABEL = {
    CLICK: 'Click',
};

const GA_PREFIX = {
    ACCESS_INDIVIDUAL_LEASE: 'AccessIndividualLease',
    OPEN_SECONDARY_MENU: 'OpenSecondaryMenu',
    SECONDARY_MENU_SELECTION: 'SecondaryMenuSelection',
    VIEW_ALL_LEASES: 'ViewAllLeases',
};

const CTA = {
    CREATE_A_LEASE: 'CreateALease',
    UPLOAD_A_LEASE: 'UploadALease',
};

const GA_EVENTS = {
    // empty state
    GET_STARTED_EMPTY_STATE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `LeasesGetStarted${DELIMITER}EmptyState`,
    },
    LEARN_MORE_EMPTY_STATE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `LearnMore${DELIMITER}EmptyState`,
    },
    // individual leases
    PRIMARY_CTA_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // AccessIndividualLease-[lease_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    SECONDARY_CTA_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // OpenSecondaryMenu-[lease_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    SECONDARY_CTA_ITEM_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // SecondaryMenuSelection-[selected_menu_value]-[lease_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    // leases management
    CREATE_LEASE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'CreateALease',
    },
    UPLOAD_LEASE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'UploadALease',
    },
    VIEW_ALL_LEASES_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `ViewAllLeases${DELIMITER}TextLink`,
    },
};

export {
    CTA,
    GA_EVENTS,
    GA_PREFIX,
};
